export const buildAddress = (obj) =>
  [
    obj?.addressLine1,
    obj?.orgAddressLineOne,
    obj?.addressLine2,
    obj?.orgAddressLineTwo,
    obj?.town,
    obj?.orgAddressTown,
    obj?.city,
    obj?.orgAddressCity,
    obj?.postCode,
    obj?.orgAddressPostCode,
  ]
    .filter(Boolean)
    .join(', ')
